import { writable } from "svelte/store";

export const chatSessions = writable([]);
export const showOnlyUnreadChat = writable(-1);
export const chatSessionsCount = writable(0);
export const notSeenSessionIds = writable([]);
export const clientChatSessionId = writable(0);
export const unreadMessages = writable(0);
